import styled from 'styled-components';

import { basicBodyTextStyle, colorsMatrix } from '@dreryk/react-components';

export const StyledWaitlistEntrySection = styled.div`
   ${basicBodyTextStyle};
   background: ${colorsMatrix.blue.lighter};
   padding: 18px;
   border-radius: 20px;
   z-index: 1;
   overflow-wrap: break-word;
`;
StyledWaitlistEntrySection.displayName = 'StyledWaitlistEntrySection';
